export const rules = [
    {max: 20000, message: 'Message cannot be longer than 20,000 characters'},
    { validator: (rule: any, value: string, cb: (msg?: string) => void) => {
           return  value.trim().length === 0 ? cb("Please fill this field") : cb();
    }}
]